import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import { verifiedIcon } from '@/assets/images/icons';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useAuth } from '@/contexts/authContext';
import { useColor } from '@/hooks/useColor';

const SummaryItem = ({ canEdit, nonProfitOrg }: { canEdit: boolean; nonProfitOrg: NonProfitOrgProfileResponse }) => {
  const { state } = useAuth();
  const colors = useColor();

  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.verifiedContainer}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {nonProfitOrg.name}
          </Text>
          {nonProfitOrg.claimed && (
            // ToDO: Change for actual title and message
            <InfoButton
              title="Verified NPO"
              message="A non-profit organization (NPO) is marked as verified once it has been claimed and approved through our admin system. This verification ensures that the organization is authentic and managed by its rightful representatives."
              type="modal"
              icon={verifiedIcon}
            />
          )}
        </View>
        {canEdit && (
          <EditButton
            onPress={() => {
              if (state.authReady && state.user?.user.role === 'INDIVIDUAL') {
                router.navigate({
                  pathname: '/edit/npoBioWiki',
                  params: {
                    npoJson: JSON.stringify(nonProfitOrg)
                  }
                });
              } else {
                router.navigate({
                  pathname: '/edit/npoGeneral',
                  params: {
                    npoJson: JSON.stringify(nonProfitOrg)
                  }
                });
              }
            }}
          />
        )}
      </View>
      {((nonProfitOrg.type === 'CHARITIES' && nonProfitOrg.showMap) || nonProfitOrg.type === 'CHURCH') && (
        <Text style={[styles.addressText, { color: colors.titleText }]} fontWeight="500">
          {nonProfitOrg.address}
        </Text>
      )}
      <Text style={styles.descriptionText} fontWeight="500">
        {nonProfitOrg.description}
      </Text>
      <Divider />
    </View>
  );
};

export default SummaryItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  verifiedContainer: {
    flexDirection: 'row',
    gap: 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: 10
  },

  titleText: {
    fontSize: 22
  },

  addressText: {
    marginTop: 10
  },

  descriptionText: {
    marginTop: 5,
    fontSize: 14,
    marginBottom: 20
  }
});
